import { render } from "./Properties.vue?vue&type=template&id=6da3f69a&scoped=true"
import script from "./Properties.vue?vue&type=script&lang=js"
export * from "./Properties.vue?vue&type=script&lang=js"

import "./Properties.vue?vue&type=style&index=0&id=6da3f69a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da3f69a"]])

export default __exports__